import React, { useCallback } from "react";
import { useBitumioContext } from "providers/BitumioContext";
import useGlobalMessage from "hooks/notifications/useGlobalMessage";
import getLocalString from "constants/Localization";

export default function useDisplayPass() {
  const [{ showLoader, hideLoader }] = useBitumioContext();
  const { show } = useGlobalMessage();

  const getPass = useCallback(async () => {
    try {
      showLoader();
      const response = await fetch(
        import.meta.env.VITE_BACKEND_API_BASE_URL + `/api/quickbooks/qbc-pass`,
        {
          credentials: "include",
        }
      );
      const data = await response.json();
      if (response.ok) {
        return data?.data;
      }
      const errorMessage = data?.message ?? '';
      show({
        message: errorMessage || getLocalString("generic.failure"),
        options: { variant: "error" },
      });
      return '';

    } catch (error) {
      show({
        message: getLocalString("generic.failure"),
        options: { variant: "error" },
      });
      return ''

    } finally {
      hideLoader();
    }
  }, []);

  const getQbcPass = useCallback(() => {
    return getPass();
  }, [getPass]);

  return [getQbcPass];
}
